import { useEffect } from 'react';

export function useSpotlight() {
  useEffect(() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return undefined;
    let frame = 0;
    let pending = null;

    const apply = () => {
      frame = 0;
      if (!pending) return;
      const { target, x, y } = pending;
      pending = null;
      const surface = target instanceof Element ? target.closest('.lit') : null;
      if (!surface) return;
      const rect = surface.getBoundingClientRect();
      surface.style.setProperty('--pointer-x', `${x - rect.left}px`);
      surface.style.setProperty('--pointer-y', `${y - rect.top}px`);
    };

    const onMove = (event) => {
      pending = { target: event.target, x: event.clientX, y: event.clientY };
      if (!frame) frame = requestAnimationFrame(apply);
    };

    document.addEventListener('pointermove', onMove, { passive: true });
    return () => {
      document.removeEventListener('pointermove', onMove);
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);
}
